import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import {
  API_URL,
  MAIN_TITLE,
  APPBAR,
  alertMessage,
  LOGOGOLDEN,
  ADDRESS,
  SUBADMISSION,
} from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import html2pdf from "html3pdf";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function RegistrationsOnboarding() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);

  const navigate = useNavigate();

  const [open2, setOpen2] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [formData, setFormData] = useState("");

  const [selectedPage, setSelectedPage] = useState("FORMS");
  const [registrations, setRegistrations] = useState("");
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [photo, setPhoto] = useState(false);
  const [base64IMG, setBase64IMG] = useState("");

  function deleteItem() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["form_id"] = selectedStudent["form_id"];
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/reject_registration", body, config)
      .then((res) => {
        setOpen2(false);

        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_registrations", body, config)
      .then((res) => {
        setRegistrations(res.data);
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    if (registrations.length == 0) {
      return (
        <div
          style={{
            marginTop: "200px",
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Fab
              size="large"
              style={{
                border: "3px solid #aaa",
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
              aria-label="add"
            >
              <PriorityHighIcon
                style={{
                  color: "grey",
                }}
              />
            </Fab>
            <br />
            <h4 style={{ color: "grey" }}>
              No registrations have been added yet.
            </h4>
          </div>
        </div>
      );
    } else {
      if (selectedPage == "FORMS") {
        return (
          <div style={{ width: "100vw", fontSize: "18px" }}>
            <h2>All Registrations</h2>
            <Grid
              container
              style={{
                paddingBottom: "5px",
                marginBottom: "5px",
                borderBottom: "1px solid #aaa",
              }}
            >
              <Grid item md={0.25}>
                Sr.
              </Grid>
              <Grid item md={1.5}>
                Form ID
              </Grid>
              <Grid item md={2}>
                Student Name
              </Grid>
              <Grid item md={1}>
                Phone Number
              </Grid>
              <Grid item md={3}>
                Email
              </Grid>
              <Grid item md={2}>
                Bank Ref NO.
              </Grid>
              <Grid item md={2}>
                Transaction ID
              </Grid>
            </Grid>
            {registrations.map((item, index) => (
              <Grid
                container
                style={{ marginTop: "15px", cursor: "pointer" }}
                onClick={() => {
                  setSelectedStudent(item);
                  setFormData(item.form_data);
                  // Fetch student photo from API
                  const photoUrl =
                    API_URL + "/media/" + item.form_id + "_photo.jpg";
                  axios
                    .get(photoUrl, {
                      headers: { Authorization: state.auth.token },
                      responseType: "arraybuffer",
                    })
                    .then((photoRes) => {
                      const base64 = btoa(
                        new Uint8Array(photoRes.data).reduce(
                          (data, byte) => data + String.fromCharCode(byte),
                          "",
                        ),
                      );
                      setBase64IMG("data:image/jpeg;base64," + base64);
                      setPhoto(true);
                    })
                    .catch(() => {
                      console.log("ERROR FETCHING PHOTO");
                      setPhoto(false);
                      setBase64IMG("");
                    });
                  setSelectedPage("RECEIPT");
                }}
              >
                <Grid item md={0.25}>
                  {index + 1}
                </Grid>
                <Grid item md={1.5}>
                  {item.form_id}
                </Grid>

                <Grid item md={2}>
                  {item.full_name}
                </Grid>
                <Grid item md={1}>
                  {item.phone_number}
                </Grid>
                <Grid item md={3}>
                  {item.email.toLowerCase()}
                </Grid>
                <Grid item md={2}>
                  {item.bank_ref_no}
                </Grid>
                <Grid item md={2}>
                  {item.txn_id}
                </Grid>
              </Grid>
            ))}
          </div>
        );
      } else {
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                fontWeight: "lighter",
              }}
            >
              <Button
                fullWidth
                style={{
                  backgroundColor: themeStyle.primaryColor,
                  color: "white",
                  width: "5%",
                  height: "35px",
                  borderTopLeftRadius: "6px",
                  borderBottomLeftRadius: "6px",
                  borderTopRightRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
                onClick={() => setSelectedPage("FORMS")}
              >
                <ArrowBackIcon style={{ fontSize: "25px" }} />
              </Button>
              <div
                textAlign="center"
                style={{
                  color: themeStyle.secondaryColor,
                  backgroundColor: themeStyle.primaryColorLight,
                  width: "95%",
                  height: "35px",
                  padding: "3px 15px 0px 25px",
                  alignItems: "center",
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                  borderTopRightRadius: "6px",
                  borderBottomRightRadius: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "18px",
                }}
              >
                <h3 style={{ marginLeft: "-10px" }}>
                  {selectedStudent.full_name}
                </h3>
              </div>
            </div>
            <div
              style={{
                borderRadius: "15px",
                width: state.auth.isMobile ? "85vw" : "60%",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: state.auth.isMobile ? "15px" : "20px",
              }}
            >
              <div
                style={{
                  padding: "24px",
                  fontFamily: "Arial, sans-serif",
                  lineHeight: "1.6",
                  color: "#000",
                }}
              >
                <div id={"pdf-element"}>
                  <div
                    style={{
                      backgroundColor: themeStyle.secondaryColor,
                      padding: "0px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <img
                        style={{
                          maxHeight: "150px",
                          margin: "10px",
                          marginLeft: "-50px",
                          marginRight: "25px",
                        }}
                        src={require("../../img/" + LOGOGOLDEN)}
                      />

                      <div>
                        <h1
                          style={{
                            textAlign: "center",
                            color: "#FFFDD0",
                            fontSize: "22px",
                          }}
                        >
                          {MAIN_TITLE}
                        </h1>
                        <br />
                        <h3
                          style={{
                            marginTop: "-15px",
                            textAlign: "center",
                            color: "#FFFDD0",
                            fontSize: "16px",
                          }}
                        >
                          {SUBADMISSION}
                        </h3>
                        <br />
                        <h2
                          style={{
                            marginTop: "-15px",
                            textAlign: "center",
                            color: "yellow",
                            textStyle: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {ADDRESS}
                        </h2>
                        <h3
                          style={{
                            textAlign: "center",
                            color: "white",
                            fontSize: "16px",
                          }}
                        >
                          Form ID: {" " + selectedStudent.form_id}
                        </h3>
                        <h3
                          style={{
                            textAlign: "center",
                            color: "white",
                            fontSize: "16px",
                          }}
                        >
                          Transaction ID {" " + selectedStudent.txn_id}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div
                    style={{
                      padding: "20px",
                      marginTop: "-15px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          marginLeft: "600px",
                          marginTop: "300px",
                          width: state.auth.isMobile ? "150px" : "12vw",
                          height: state.auth.isMobile ? "200px" : "15.5vw",
                          backgroundColor: photo ? "#fff" : "#eee",
                          border: photo
                            ? "5px solid" + themeStyle.primaryColor
                            : "2px solid #ccc",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {base64IMG.length == 0 ? (
                          <CircularProgress />
                        ) : (
                          <img
                            src={`${base64IMG}`}
                            alt="Photograph"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <h3>Student Information</h3>
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            First Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.firstName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Middle Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.middleName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Last Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.lastName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Aadhar Number
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.aadharNo}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Date of Birth
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.dateOfBirth}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Gender
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.gender}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Religion
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.religion}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            STS Number
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.stsNumber}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            PEN Number
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.penNumber}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Sibling Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.siblingName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Sibling Class
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.siblingClass}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Sibling Division
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.siblingDivision}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Place of Birth
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.placeOfBirth}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Mother Tongue
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.motherTongue}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Permanent Address
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.permanentAddress}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Is CSI
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.student.isCSI ? "Yes" : "No"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    style={{
                      marginTop: "67px",
                      padding: "24px",
                    }}
                  >
                    <h3>Mother Information</h3>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "-10px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Full Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.fullName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Profession
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.profession}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Qualification
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.qualification}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Income Per Annum
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.incomePerAnnum}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Office Address
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.officeAddress}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Mobile
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.mobile}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Email
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.mother.email}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div style={{ padding: "24px", marginTop: "-50px" }}>
                    <h3>Father Information</h3>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "-10px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Full Name
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.fullName}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Profession
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.profession}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Qualification
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.qualification}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Income Per Annum
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.incomePerAnnum}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Office Address
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.officeAddress}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Mobile
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.mobile}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Email
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.father.email}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    style={{
                      marginTop: "-50px",
                      padding: "24px",
                    }}
                  >
                    <h3>Other Information</h3>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "-10px",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Guardian
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.guardian}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Are Parents Old Students
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.areParentsOldStudents}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Admission For
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.admissionFor}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Relationship to Guardian
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.relationshipToGuardian}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Address of Guardian
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.addressOfGuardian}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Other Information
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.others.otherInformation}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              fontWeight: "bold",
                            }}
                          >
                            Date
                          </td>
                          <td
                            style={{ border: "1px solid #ccc", padding: "8px" }}
                          >
                            {formData.declaration.date}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <br />
                    <br />
                    <Typography variant="h6">Criteria for admission</Typography>
                    <div style={{ textAlign: "left", marginTop: "15px" }}>
                      <p>
                        1. Age criteria: The child should be 4 years as on June
                        01, 2026. The minimum age should be 4 years and the
                        maximum age permissible shall be 5 years. Attested
                        copies of the Birth Certificate issued by the
                        Corporation must bear the name of the child.{" "}
                      </p>

                      <p>
                        2. As proof of residence a photocopy of either the Voter
                        ID, Passport, Aadhaar Card or rental agreement must be
                        submitted.
                      </p>
                      <p>
                        3. Attested copies of both the parents' highest
                        educational qualification is mandatory
                      </p>
                    </div>
                    <Typography variant="h6">Declaration</Typography>
                    <div style={{ textAlign: "left" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={true}
                            style={{
                              transform: "scale(1.5)",
                              color: themeStyle.primaryColor,
                            }}
                            onChange={() => {}}
                          />
                        }
                        label="I herewith declare that all the information furnished by me in this application is true to the best of my knowledge. I also herewith declare that i will not claim any refund of any of the payments under any circumstances"
                      />{" "}
                      <br />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={true}
                            style={{
                              transform: "scale(1.5)",
                              color: themeStyle.primaryColor,
                            }}
                            onChange={() => {}}
                          />
                        }
                        label="I herewith declare that all the information furnished by me in this application is true to the best of my knowledge. I also herewith declare that i will not claim any refund of any of the payments under any circumstances"
                      />
                    </div>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>Date: </div>
                      <div
                        style={{ width: "500px", borderTop: "2px solid black" }}
                      >
                        Signature of Parent / Guardian
                      </div>
                    </div>
                    <br /> <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>Date: </div>
                      <div
                        style={{ width: "500px", borderTop: "2px solid black" }}
                      >
                        Signature of Principal
                      </div>
                    </div>
                    <br />
                    <hr />
                    <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                      FOR OFFICE USE ONLY
                    </div>
                    <br />
                    <div>
                      1) Birth Certificate (copy) <br /> <br />
                      2) Transfer Certificate / School Leaving Certificate{" "}
                      <br /> <br />
                      3) Progress Report <br /> <br /> 4) Aadhar Card (copy)
                      <br /> <br /> 5) Fees paid <br />
                      Amount: ____________
                    </div>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>Date: </div>
                      <div
                        style={{ width: "500px", borderTop: "2px solid black" }}
                      >
                        Signature of the receiving authority
                      </div>
                    </div>
                  </div>
                </div>
                <Button
                  style={{
                    height: "35px",
                    margin: "6px 0px 15px 0px",
                    border: "1px solid #3182bd",
                    backgroundColor: themeStyle.primaryColor,
                    boxShadow: "none",
                  }}
                  variant={"contained"}
                  fullWidth
                  onClick={() => {
                    setIsLoadingDownload(true);
                    var element = document.getElementById("pdf-element");
                    html2pdf(element).then((_) => {
                      setIsLoadingDownload(false);
                      createAlert(
                        "SUCCESS",
                        "Success!",
                        "Download successful.",
                      );
                    });
                  }}
                >
                  <h4>Download PDF</h4>
                </Button>
                {isLoadingDownload ? (
                  <div
                    style={{
                      borderRadius: "15px",
                      marginTop: "20px",
                      padding: "20px",
                      width: "100%",
                      backgroundColor: "white",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress />
                    <h3 style={{ textAlign: "center" }}>
                      Downloading attendance
                      <br />
                      This might take a couple of minutes...
                    </h3>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {selectedStudent["birth_link"].length != 0 ? (
                <a
                  href={selectedStudent["birth_link"]}
                  target="_blank"
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                >
                  <h2>Birth Certificate</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["leaving_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["leaving_link"]}
                  target="_blank"
                >
                  <h2>Leaving Certificate</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["progress_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["progress_link"]}
                  target="_blank"
                >
                  <h2>Progress Report</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["aadhar_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["aadhar_link"]}
                  target="_blank"
                >
                  <h2>Aadhar Card</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["parent1_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["parent1_link"]}
                  target="_blank"
                >
                  <h2>Parent 1 Qualification</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["parent2_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["parent2_link"]}
                  target="_blank"
                >
                  <h2>Parent 2 Qualification</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["baptism_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["baptism_link"]}
                  target="_blank"
                >
                  <h2>Baptism Certificate</h2>
                </a>
              ) : (
                ""
              )}
              {selectedStudent["church_link"].length != 0 ? (
                <a
                  style={{
                    textDecoration: "underline",
                    color: themeStyle.primaryColor,
                    cursor: "pointer",
                  }}
                  href={selectedStudent["church_link"]}
                  target="_blank"
                >
                  <h2>Church Membership</h2>
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      }
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_onboarding) {
        return (
          <Fragment>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{
                    borderRadius: "15px",
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3>Reject this form?</h3>
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>

                    <span>This action cannot be reversed.</span>
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={() => deleteItem()}
                        style={{ height: "30px" }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                      <Button
                        style={{ height: "30px", marginLeft: "10px" }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>

            <Sidebar />
            <div
              style={{
                borderRadius: "15px",
                margin: "38px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      } else {
        createAlert(
          "ERROR",
          "Permission Denied.",
          "Please Login as Onboarding",
        );
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default RegistrationsOnboarding;
